// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  padding: 20px;
}
.wrapper .header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0px 20px;
}
.wrapper .header ion-icon {
  fill: white;
  color: white;
}
.wrapper .country-list {
  width: 100%;
  padding: 10px 0px;
  max-height: 400px;
  overflow: auto;
}
.wrapper .country-list .country {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  width: 100%;
  background: white;
  border-radius: 10px;
  margin: 10px 0px;
}
.wrapper .country-list .country ion-icon {
  width: 25px;
  padding-right: 10px;
}
.wrapper .country-list .country h3 {
  width: calc(100% - 55px);
  font-family: Tusker, sans-serif;
  font-size: 14px;
  text-align: left;
}
.wrapper .country-list .country .selected-circle {
  width: 25px;
  height: 25px;
  background: transparent;
  border: 2.5px solid var(--ion-color-secondary);
  border-radius: 50%;
  position: relative;
}
.wrapper .country-list .country .selected-circle .inner-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 15px;
  height: 15px;
  background: var(--ion-color-secondary);
  border-radius: 50%;
  visibility: hidden;
  opacity: 0;
}
.wrapper .country-list .country .selected-circle .inner-circle.show {
  visibility: visible;
  opacity: 1;
  transition: ease-in-out 0.5s;
}`, "",{"version":3,"sources":["webpack://./src/app/components/input-phone-with-county-code/custom-modal-with-country-selection/custom-modal-with-country-selection.component.scss"],"names":[],"mappings":"AACA;EACI,aAAA;AAAJ;AACI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AACR;AAAQ;EACI,WAAA;EACA,YAAA;AAEZ;AACI;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;AACR;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEZ;AADY;EACI,WAAA;EACA,mBAAA;AAGhB;AADY;EACI,wBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAGhB;AADY;EACI,WAAA;EACA,YAAA;EACA,uBAAA;EACA,8CAAA;EACA,kBAAA;EACA,kBAAA;AAGhB;AAFgB;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAIpB;AAHoB;EACI,mBAAA;EACA,UAAA;EACA,4BAAA;AAKxB","sourcesContent":["\n.wrapper {\n    padding: 20px;\n    .header {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: flex-end;\n        padding: 10px 0px 20px;\n        ion-icon {\n            fill: white;\n            color: white;\n        }\n    }\n    .country-list {\n        width: 100%;\n        padding: 10px 0px;\n        max-height: 400px;\n        overflow: auto;\n        .country {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            padding:10px;\n            width: 100%;\n            background: white;\n            border-radius: 10px;\n            margin:  10px 0px;\n            ion-icon {\n                width: 25px;\n                padding-right: 10px;\n            }\n            h3 {\n                width: calc(100% - 55px);\n                font-family: Tusker,sans-serif;\n                font-size: 14px;\n                text-align: left;\n            }\n            .selected-circle {\n                width: 25px;\n                height: 25px;\n                background: transparent;\n                border: 2.5px solid var(--ion-color-secondary);\n                border-radius: 50%;\n                position: relative;\n                .inner-circle {\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translate(-50%, -50%);\n                    width: 15px;\n                    height: 15px;\n                    background: var(--ion-color-secondary);\n                    border-radius: 50%;\n                    visibility: hidden;\n                    opacity: 0;\n                    &.show {\n                        visibility: visible;\n                        opacity: 1;\n                        transition: ease-in-out 0.5s;\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
